import { memo } from 'react';
import { ArrowProps } from './Arrow.types';
import icons from '@betty/moonlight/lib/assets/icons';
import styles from './Arrow.module.css';

function Arrow(props: ArrowProps) {
  const { onClick, disabled, type } = props;

  if (disabled) {
    return null;
  }

  const ArrowBackIcon = icons[
    'arrowForward' as keyof typeof icons
  ] as React.FC<{ className?: string }>;

  return (
    <button
      className={`${styles.button} ${type === 'Back' ? styles.left : styles.right}`}
      onClick={onClick}
    >
      <ArrowBackIcon className={styles.arrow} />
    </button>
  );
}

export default memo(Arrow);
